// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3T_YG","event-title":"_2eNGl","events":"-QeAq","events-list":"_2Txi8","event-date":"_1Xe2E","event-content":"_2kag5","reverse":"_3a1i6"};